import React from 'react';
import triangle from 'assets/triangle.svg';
import v from 'vudu';

const localClasses = v({
  playButton: {
    width: '90px',
    height: '90px',
    backgroundColor: 'transparent',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: 'rgba(255, 255, 255, 0.2)',
    borderStyle: 'solid',
    borderWidth: '2px',
    cursor: 'pointer'
  },
  playButtonInner: {
    width: '79px',
    height: '79px',
    backgroundColor: 'transparent',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderColor: 'rgba(255, 255, 255, 0.6)',
    borderStyle: 'solid',
    borderWidth: '2px',
    backgroundImage: 'linear-gradient(133deg, rgba(255,255,255,0.12) 0%, rgba(255,255,255,0.00) 100%)',
    ':hover': {
      backgroundImage: 'linear-gradient(133deg, rgba(255,255,255,0.6) 0%, rgba(255,255,255,0.00) 100%)',
    },
    'img': {
      marginLeft: '6px',
      boxShadow: '1px 2px 12px 0 rgba(0,0,0,0.25)'
    }
  }
});

export default (props) => (
  <div className={localClasses.playButton} onClick={() => props.setVideoOverlay(true)}>
    <div className={localClasses.playButtonInner}>
      <img src={triangle} alt={'Play'} />
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/PlayButton.js